import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-ag-status-type-badge',
  templateUrl: './ag-status-type-badge.component.html',
  styleUrls: ['./ag-status-type-badge.component.scss']
})
export class AgStatusTypeBadgeComponent implements OnInit, ICellRendererAngularComp {
  label = 'Unknown';
  bg = '#E9EDF2';
  color = '#4B5563';
  tooltipContent: string = '';
  params: any;
  constructor() { }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    const status = typeof params.value === 'string' ? params.value : 'Unknown';
    const style = getStatusStyle(status);
    let toolContent = `Po Number ${params?.data?.poNumber ?? ''}\n` + `Qty ${params?.data?.qty ?? ''}`;
    this.tooltipContent = toolContent || '';
    
    const bgColors: any = {
      'Expired': '#8B9DAA',
      'New Alt': '#8B9DAA',
      'Purchased': '#DE466D',
      'New Offer': '#DE466D',
      'Unknown': '#E9EDF2',
    };

    const textColors: any = {
      'Active': '#DE466D',
      'Expired': '#FFFFFF',
      'New Part': '#DE466D',
      'New Alt': '#FFFFFF',
      'Currency': '#0067AC',
      'Purchased': '#FFFFFF',
      'New Offer':'#FFFFFF',
      'Unknown': '#4B5563',
    };

    this.label = style.label;
    this.bg = bgColors[params.value] ?? bgColors['Unknown'];
    this.color = textColors[params.value] ?? textColors['Unknown'];
  }

  refresh(): boolean {
    return false;
  }

  ngOnInit(): void {
  }

}

export const STATUS_STYLES = { 'Active': { label: 'Active' }, 'Expired': { label: 'Expired' }, 'New Part': { label: 'New Part' }, 'New Alt': { label: 'New Alt' }, 'Currency': { label: 'Currency' }, 'Purchased': { label: 'Purchased' }, 'default': { label: 'Unknown' } } as const;

export function getStatusStyle(status: string | null | undefined) {
  if (!status) return STATUS_STYLES['default'];
  const normalized = status.trim().toLowerCase();

  if (STATUS_STYLES[status as keyof typeof STATUS_STYLES]) {
    return STATUS_STYLES[status as keyof typeof STATUS_STYLES];
  }
  if (STATUS_STYLES[normalized as keyof typeof STATUS_STYLES]) {
    return STATUS_STYLES[normalized as keyof typeof STATUS_STYLES];
  }

  return STATUS_STYLES['default'];
}
